import React from "react";
import { Group, Icon, Separator } from "@salestrak/ui";

import { ControlBarButton } from "@salestrak/ui";
import { MapControlButton } from "./map-control-button";

type MapZoomControlsProps = {
  isDark: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  zoomLevel: number;
  minZoom: number;
  maxZoom: number;
};

export function MapZoomControls({
  isDark,
  onZoomIn,
  onZoomOut,
  zoomLevel,
  minZoom,
  maxZoom,
}: MapZoomControlsProps) {
  return (
    // Icon paints with `currentColor` and the control card's background tracks
    // the app theme, so the muted token — not the map palette's resolved
    // `controlIcon` hex — is the right tint for these glyphs.
    <MapControlButton isDark={isDark}>
      <Group orientation="vertical">
        <ControlBarButton
          disabled={zoomLevel >= maxZoom}
          label="Zoom in"
          onClick={onZoomIn}
          size="icon-lg"
        >
          <Icon color="muted" name="plus" size="lg" />
        </ControlBarButton>
        <Separator orientation="horizontal" />
        <ControlBarButton
          disabled={zoomLevel <= minZoom}
          label="Zoom out"
          onClick={onZoomOut}
          size="icon-lg"
        >
          <Icon color="muted" name="minus" size="lg" />
        </ControlBarButton>
      </Group>
    </MapControlButton>
  );
}
